import React from "react";

const StatisticCard = ({ name, value }) => {
  return (
    <div className="flex flex-row justify-between items-center gap-2 w-full">
      <div className="p-2 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg text-xl">
        {name}
      </div>
      <div className="text-xl sm:text-2xl font-bold text-gray-800 text-right">
        {value}
      </div>
    </div>
  );
};

export default StatisticCard;
